var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { t, Translate } from "../../I18N";
import { Icon } from "./..";








const computeVisiblePages = (activePage, totalPages) => {
  if (totalPages < 6) {
    return _.range(1, totalPages + 1);
  }
  if (activePage % 5 >= 0 && activePage > 4 && activePage + 2 < totalPages) {
    return [1, activePage - 1, activePage, activePage + 1, totalPages];
  }
  if (activePage % 5 >= 0 && activePage > 4 && activePage + 2 >= totalPages) {
    return [1, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }
  return [1, 2, 3, 4, 5, totalPages];
};

function pageLabel(array, index, pageNumber) {
  return array[index - 1] + 2 < pageNumber ||
  pageNumber > 1 && array[index - 1] !== pageNumber - 1 ?
  `...${pageNumber}` :
  pageNumber;
}

const Pagination = ({
  totalPages,
  resetActivePage,
  onPageChange,
  onPageSizeChange
}) => {
  const [activePage, setActivePage] = useState(1);
  const [visiblePages, setVisiblePages] = useState(computeVisiblePages(1, totalPages));
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    setVisiblePages(computeVisiblePages(activePage, totalPages));
  }, [activePage, totalPages]);

  useEffect(() => {
    if (resetActivePage) {
      setActivePage(1);
    }
  }, [resetActivePage]);

  const changePage = (page) => {
    if (page !== activePage) {
      setActivePage(page);
      onPageChange(page - 1);
    }
  };

  function PageNumbers() {
    return visiblePages.map((pageNumber, index, array) => /*#__PURE__*/
    _jsx("button", {
      type: "button",

      className: activePage === pageNumber ? 'page-button active' : 'page-button',
      onClick: () => changePage(pageNumber) }, pageNumber,

    pageLabel(array, index, pageNumber)));


  }

  return /*#__PURE__*/(
    _jsx("div", {}, void 0,
    totalPages > 0 && /*#__PURE__*/
    _jsx("div", { className: "table-pagination" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "page-numbers" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "prev-page" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "page-button",
      onClick: () => {
        if (activePage !== 1) {
          changePage(activePage - 1);
        }
      },
      disabled: activePage === 1 }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "angle-double-left" }), "\xA0", /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Previous"))), /*#__PURE__*/


    _jsx("div", { className: "visible-pages" }, void 0, PageNumbers()), /*#__PURE__*/
    _jsx("div", { className: "next-page" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "page-button",
      onClick: () => {
        if (activePage !== totalPages) {
          changePage(activePage + 1);
        }
      },
      disabled: activePage === totalPages }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Next"), "\xA0", /*#__PURE__*/

    _jsx(Icon, { icon: "angle-double-right" })))), /*#__PURE__*/



    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("select", {
      value: pageSize,
      onChange: (e) => {
        const newSize = Number(e.target.value);
        setPageSize(newSize);
        onPageSizeChange(newSize);
      } }, void 0,

    [100, 300, 500].map((size) => /*#__PURE__*/
    _jsx("option", { value: size }, size,
    `${size} ${t('System', 'per page', null, false)}`)))))));








};

export { Pagination };